import { buildSidebarContext } from "./shared/sidebar.shared";
import { getMenuList as getDefaultMenuList } from "./types/sidebar.default";
import { getMenuList as getType3MenuList } from "./types/sidebar.customerType3";
import { getMenuList as getType7MenuList } from "./types/sidebar.customerType7";
import { getMenuList as getEasyAccessOperatorMenuList } from "./types/sidebar.easyAccessOperator";

/**
 * Resolves sidebar menu list from auth and location.
 * Applies the same condition order as the original Sidebar.
 * @param {Object} params - same as buildSidebarContext
 * @returns {Array} menu list for JumboVerticalNavbar
 */
export function resolveSidebarMenuList({
  customer,
  type,
  userId,
  location,
  searchParams,
  partnerUser,
}) {
  const pathname = location?.pathname || "";
  const isPartner = pathname.startsWith("/manage");
  const isServicePartnerCustomer =
    customer?.customerType === 7 || customer?.customer_type === 7;

  if (isPartner) {
    const context = buildSidebarContext({
      customer,
      type,
      userId,
      location,
      searchParams,
      partnerUser,
    });
    return [context.partnerMenu].filter(Boolean);
  }

  if (isServicePartnerCustomer) {
    return getType7MenuList();
  }

  const context = buildSidebarContext({
    customer: customer || null,
    type,
    userId,
    location,
    searchParams,
    partnerUser,
  });

  if (context.easyAccessOperator) {
    return getEasyAccessOperatorMenuList(context);
  }
  if (context.easyPayOperator) {
    return getDefaultMenuList(context);
  }
  const isCustomerType3 =
    customer?.customerType === 3 || customer?.customer_type === 3;
  if (context.datavisionCustomer || isCustomerType3) {
    return getType3MenuList(context);
  }
  return getDefaultMenuList(context);
}
